import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as taskSchedulerSlice from './taskSchedulerSlice';

export default function* watchTaskSchedulerSaga() {
	yield takeLatest(taskSchedulerSlice.getTableStart.type, commonSagas.getTable);
	yield takeLatest(taskSchedulerSlice.getItemStart.type, commonSagas.getItem);
	yield takeLatest(
		taskSchedulerSlice.createItemStart.type,
		commonSagas.createItem,
	);
	yield takeLatest(
		taskSchedulerSlice.updateItemStart.type,
		commonSagas.updateItem,
	);
	yield takeLatest(
		taskSchedulerSlice.deleteItemsStart.type,
		commonSagas.deleteItems,
	);
	yield takeLatest(
		taskSchedulerSlice.deleteItemStart.type,
		commonSagas.deleteItem,
	);
	yield takeLatest(
		taskSchedulerSlice.getTableStructureStart.type,
		commonSagas.getTableStructure,
	);
	yield takeLatest(
		taskSchedulerSlice.getTableExcelStart.type,
		commonSagas.getTableExcel,
	);
}
